export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/vat-sales-list/:pageId',
        component: () => import('@/views/page/company/core-accounting/nbr/VatSalesList.vue'),
        name: 'vat-sales-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/vat-purchase-sales-book/:pageId',
        component: () => import('@/views/page/company/core-accounting/nbr/VatPurchaseSalesBook.vue'),
        name: 'vat-purchase-sales-book',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/vat-purchase-book/:pageId',
        component: () => import('@/views/page/company/core-accounting/nbr/VatPurchaseBook.vue'),
        name: 'vat-purchase-book',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/vat-sales-book/:pageId',
        component: () => import('@/views/page/company/core-accounting/nbr/VatSalesBook.vue'),
        name: 'vat-sales-book',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/vat-credit-note/:pageId',
        component: () => import('@/views/page/company/core-accounting/nbr/VatCreditNote.vue'),
        name: 'vat-credit-note',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/vat-debit-note/:pageId',
        component: () => import('@/views/page/company/core-accounting/nbr/VatDebitNote.vue'),
        name: 'vat-debit-note',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/input-output-coefficient/:pageId',
        component: () => import('@/views/page/company/core-accounting/nbr/InputOutputCoefficient.vue'),
        name: 'input-output-coefficient',
        meta: {
            requiresAuth: true
        }
    },
]
